import type { LocationItem, LocationLevel, Lookups } from '@re/form-ui';
import { useQuery } from '@tanstack/react-query';
import { api } from './client';

/** Active master data (request types, categories, property types, features). */
export function useLookups() {
  return useQuery({ queryKey: ['lookups'], queryFn: () => api<Lookups>('/lookups'), staleTime: 5 * 60_000 });
}

export async function loadLocations(level: LocationLevel, parentId?: number): Promise<LocationItem[]> {
  const r = await api<{ items: LocationItem[] }>(`/lookups/locations/${level}`, { query: { parentId } });
  return r.items;
}
